import React from 'react'
import { useFlags } from 'shared/components/common/FlagsProvider'
import type { FilesGridProps } from './FilesGridNext'
import FilesGridLegacy from './FilesGridLegacy'
import FilesGridNext from './FilesGridNext'

export type { FilesGridProps } from './FilesGridNext'

/**
 * Switches between the restyled file grid (part of the new file editor
 * experience) and the legacy grid based on the `new-file-editor` LaunchDarkly
 * flag (companyId-targeted). In contexts without an LDProvider (e.g.
 * customer-view) the flag evaluates falsy and the legacy grid is used.
 */
function FilesGrid(props: FilesGridProps) {
  const { newFileEditor } = useFlags()

  return newFileEditor ? <FilesGridNext {...props} /> : <FilesGridLegacy {...props} />
}

export default FilesGrid
